import { Styles } from 'shared/types';

export const Title: Styles = {
  py: 1,
  px: 2,
};
